import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_CZ.json';
import exercises from './FITNESS_EXERCISES_CZ.json';
import recipes from './FITNESS_RECIPES_CZ.json';

export const FITNESS_DATA_CZ: ServiceData = {
  articles,
  exercises,
  recipes,
};
